import { useState } from "react";
import { Building2, CreditCard, Gamepad2, HandCoins, Loader2, ShieldCheck, Wrench } from "lucide-react";
import { Toaster, toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SERVICES = [
  { lookup_key: "sinal_projeto", name: "Sinal do Projeto", price: "R$ 250", desc: "Entrada para começar seu site agora mesmo", icon: HandCoins },
  { lookup_key: "site_empresarial", name: "Site Empresarial", price: "R$ 1.500", desc: "Site completo para sua empresa", icon: Building2 },
  { lookup_key: "site_games", name: "Site de Jogo / eSports", price: "R$ 350", desc: "Plataforma imersiva para seu jogo", icon: Gamepad2 },
  { lookup_key: "manutencao_mensal", name: "Manutenção Mensal", price: "R$ 50/mês", desc: "Site sempre no ar, seguro e atualizado", icon: Wrench },
];

export const PaymentsSection = () => {
  const [loading, setLoading] = useState(null);

  const pay = async (lookupKey) => {
    setLoading(lookupKey);
    try {
      const res = await fetch(`${API}/payments/checkout`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ lookup_key: lookupKey, origin_url: window.location.origin }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Erro ao iniciar pagamento");
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(err.message);
      setLoading(null);
    }
  };

  return (
    <div className="mt-6 rounded-2xl border border-[#22222A] bg-[#101014]">
      <div className="flex flex-wrap items-center justify-between gap-3 border-b border-[#1A1A20] px-8 py-5">
        <div className="flex items-center gap-3">
          <CreditCard className="h-5 w-5 text-[#E50914]" />
          <div>
            <h2 className="font-display text-lg font-bold">Pagamentos</h2>
            <p className="text-xs text-zinc-500">Pague seu projeto com cartão, com segurança Stripe</p>
          </div>
        </div>
        <span className="flex items-center gap-1.5 rounded-full border border-[#2A2A33] px-3 py-1 font-mono-code text-[10px] uppercase tracking-widest text-zinc-500">
          <ShieldCheck className="h-3.5 w-3.5 text-[#E50914]" />
          Modo teste
        </span>
      </div>

      <div className="grid grid-cols-1 gap-4 p-6 sm:grid-cols-2" data-testid="payments-list">
        {SERVICES.map((s) => (
          <div key={s.lookup_key} data-testid={`payment-card-${s.lookup_key}`} className="card-glow rounded-xl border border-[#22222A] bg-[#0A0A0C] p-6">
            <div className="flex items-center gap-3">
              <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-[#E50914]/30 bg-[#E50914]/10">
                <s.icon className="h-5 w-5 text-[#E50914]" />
              </div>
              <div>
                <div className="font-display text-sm font-bold text-zinc-100">{s.name}</div>
                <div className="font-display text-lg font-extrabold text-[#E50914]">{s.price}</div>
              </div>
            </div>
            <p className="mt-3 text-xs leading-relaxed text-zinc-500">{s.desc}</p>
            <button
              data-testid={`payment-pay-btn-${s.lookup_key}`}
              onClick={() => pay(s.lookup_key)}
              disabled={loading !== null}
              className="btn-red-glow mt-5 flex h-11 w-full items-center justify-center gap-2 rounded-full bg-[#E50914] font-mono-code text-xs font-bold uppercase tracking-widest text-white disabled:opacity-50"
            >
              {loading === s.lookup_key ? <Loader2 className="h-4 w-4 animate-spin" /> : <CreditCard className="h-4 w-4" />}
              Pagar agora
            </button>
          </div>
        ))}
      </div>
      <p className="px-8 pb-6 font-mono-code text-[10px] uppercase tracking-widest text-zinc-600">
        Ambiente de testes — use o cartão 4242 4242 4242 4242
      </p>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#101014", border: "1px solid #22222A", color: "#F4F4F6" } }} />
    </div>
  );
};
